import React, {ReactNode} from "react";
import {observer} from "mobx-react-lite";


import {FormHint} from "../../../../components/FormHint";
import {InfoIcon} from "../../../../components/icons/InfoIcon";


import "./SideModalContentBlock.css"


export interface SideModalContentBlockProps {
    header: string;
    description?: string;
    mainContent: ReactNode;
    infoText?: string;
    isRequired?: boolean;
}

export const SideModalContentBlock = observer((
    {
        header,
        description,
        mainContent,
        infoText,
        isRequired
    }: SideModalContentBlockProps) => {

    return (
        <div className="SideModalContentBlock">
            <span className="title-medium SideModalContentBlock__header ">
                {header}
                {isRequired && <span className="SideModalContentBlock__requiredField">*</span>}
            </span>
            {description &&
                <span className="body-medium SideModalContentBlock__description">
                    {description}
                </span>
            }
            {mainContent}
            {infoText &&
                <FormHint
                    size={"small"}
                    className="SideModalContentBlock__bottomText"
                    icon={<InfoIcon size={16}/>}
                    text={infoText}/>
            }
        </div>
    );
});
